export const ARRAY_KEYS = ['cards', 'characters', 'lines', 'notes', 'places', 'tags']
